import React from 'react'
import EmptyState from '../../../../components/EmptyScreen'
import RestaurantDishesCard from '../../../../components/restaurant/RestaurantDishesCard'
import { ROUTES } from '../../../../helpers/routes-helper'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import { Dish } from '../../../../types'
import {
  SearchDishInnerGrid,
  SearchDishMainGrid,
} from '../styled/SearchDish.styled'
import ImpressionTracker from '../../../../components/analytics/ImpressionTracker'
import { logEvent } from '../../../../analytics/analytics'

interface SearchDishProps {
  dishList: Dish[]
  // Threaded from SearchResults so a dish click on the results page emits a joinable query->selection
  // pair (previously only dish_impression fired here). search_result_selected is guarded on both.
  searchId?: string
  term?: string
}

const SearchDish: React.FC<SearchDishProps> = ({ dishList, searchId, term }) => {
  const { navigate } = useAppUtilities()

  return (
    <SearchDishMainGrid>
      {dishList.length > 0 &&
        dishList.map((dish, index) => {
          return (
            <SearchDishInnerGrid key={index}>
              <ImpressionTracker
                onImpress={() =>
                  logEvent('dish_impression', {
                    restaurant_id: dish.restaurant ?? '',
                    dish_id: dish.dishID,
                    rank_position: index,
                    screen_name: 'dish_search',
                  })
                }
              >
                <div
                  onClick={() => {
                    if (dish.dishID && searchId) {
                      logEvent('search_result_selected', {
                        search_id: searchId,
                        dish_id: dish.dishID,
                        restaurant_id: dish.restaurant ?? undefined,
                        rank_position: index,
                        term,
                        result_type: 'dish',
                        result_label: dish?.name ?? undefined,
                        screen_name: 'search_results',
                      })
                    }
                    navigate(
                      `${ROUTES.RESTAURANT_DETAILS}/${dish?.restaurant}/details`,
                    )
                  }}
                >
                  <RestaurantDishesCard
                    id={dish.dishID}
                    key={index}
                    image={'/logoLetter-resize.svg'}
                    title={dish?.name}
                    description={dish?.description}
                  />
                </div>
              </ImpressionTracker>
            </SearchDishInnerGrid>
          )
        })}
      {dishList.length === 0 && (
        <EmptyState
          containerHeight={'600px'}
          mainText="Oops! No Results Found"
        />
      )}
    </SearchDishMainGrid>
  )
}

export default SearchDish
